module.exports = __webpack_public_path__ + "static/img/logo_skoltech_rus.7f818c8.png";


//////////////////
// WEBPACK FOOTER
// ./site/deeptensor/assets/pictures/logo_skoltech_rus.png
// module id = +M4T
// module chunks = 8